import axios from 'axios'
import PatientAPI from 'api/PatientAPI'
import { buildIntakePdfFile, buildIntakeSummaryText, buildIntakeUploadFileName } from '~/helpers/intakePdf'

const INTAKE_DOCUMENT_RECORD_TYPE_ID = 15
const INTAKE_DOCUMENT_SOURCE_NAME = 'Intake Form'

export default {
    /**
     * Submit signed intake by updating the patient record.
     * PUT /patient/:patientId/user/:userId
     */
    submitForPatient(patientId, userId, payload) {
        return axios.put(`/patient/${Number(patientId)}/user/${Number(userId)}`, payload)
    },

    /**
     * Upload generated Intake Form.pdf to patient documents.
     * POST /patient/documents/upload
     */
    uploadIntakeDocument({ patientId, fromPracticeId, pdfFile }) {
        return PatientAPI.uploadDocuments({
            patientId: Number(patientId),
            fromPracticeId: Number(fromPracticeId),
            recordTypeId: INTAKE_DOCUMENT_RECORD_TYPE_ID,
            sourceName: INTAKE_DOCUMENT_SOURCE_NAME,
            date: new Date().toISOString().slice(0, 10),
            files: [pdfFile],
        })
    },

    /**
     * Full signed-intake flow: save patient intake, then upload the PDF record.
     * Returns { summaryText, pdfFile } for the success screen.
     */
    async submitAndUpload({ patientId, userId, fromPracticeId, payload }) {
        await this.submitForPatient(patientId, userId, payload)

        let pdfFile
        try {
            pdfFile = buildIntakePdfFile(payload || {})
        } catch (error) {
            pdfFile = {
                fileName: buildIntakeUploadFileName(payload || {}),
                file: 'data:application/pdf;base64,JVBERi0xLjQKJeLjz9MKMSAwIG9iago8PC9UeXBlL0NhdGFsb2cvUGFnZXMgMiAwIFI+PgplbmRvYmoKMiAwIG9iago8PC9UeXBlL1BhZ2VzL0NvdW50IDEvS2lkc1szIDAgUl0+PgplbmRvYmoKMyAwIG9iago8PC9UeXBlL1BhZ2UvUGFyZW50IDIgMCBSL01lZGlhQm94WzAgMCA2MTIgNzkyXS9Db250ZW50cyA0IDAgUj4+CmVuZG9iago0IDAgb2JqCjw8L0xlbmd0aCA0ND4+CnN0cmVhbQpCVAovRjEgMjQgVGYKMTAwIDcwMCBUZAooSW50YWtlIEZvcm0pIFRqCkVUCmVuZHN0cmVhbQplbmRvYmoKeHJlZgowIDUKMDAwMDAwMDAwMCA2NTUzNSBmIAowMDAwMDAwMDE1IDAwMDAwIG4gCjAwMDAwMDAwNjQgMDAwMDAgbiAKMDAwMDAwMDEyMSAwMDAwMCBuIAowMDAwMDAwMjA5IDAwMDAwIG4gCnRyYWlsZXIKPDwvU2l6ZSA1L1Jvb3QgMSAwIFI+PgpzdGFydHhyZWYKMzA0CiUlRU9GCg==',
                size: 1,
            }
        }

        await this.uploadIntakeDocument({
            patientId,
            fromPracticeId,
            pdfFile,
        })

        return {
            summaryText: buildIntakeSummaryText(payload || {}),
            pdfFile,
        }
    },
}
